import { Layout } from '../../../../app/package/base/types';
import type { DeviceType } from '../../../../global';
import type { LobbyCategory, LobbyGame } from '../api/package/gaming/gaming-domain';

export function filterUserBasedCategories(categories: LobbyCategory[]): LobbyCategory[] {
  return categories.filter((category) => !category.isUserBased);
}

function adaptGameToLayout(game: LobbyGame, layout: Layout): LobbyGame {
  if (layout === Layout.Mobile) {
    game.img = game.imgMobile ?? game.img;
  }
  game.imgMobile = undefined;
  return game;
}

function adaptGamesToLayout(games: LobbyGame[], layout: Layout): LobbyGame[] {
  return games.map((game) => adaptGameToLayout(game, layout));
}

function adaptCategoryToLayout(category: LobbyCategory, layout: Layout): LobbyCategory {
  // category display
  if (layout === Layout.Mobile) {
    category.display = category.displayMobile ?? category.display;
  }
  category.displayMobile = undefined;
  if (category.games === undefined) {
    return category;
  }
  // category games
  category.games = adaptGamesToLayout(category.games, layout);
  return category;
}

export function adaptCategoriesToLayout(categories: LobbyCategory[], layout: Layout): LobbyCategory[] {
  return categories.map((category) => adaptCategoryToLayout(category, layout));
}

/**
 * Filters out games with an exclude.devices option that include the current device type
 * {"exclude": {"devices": ["ios", "android", "desktop"]}}
 */
export function filterGamesByDevice(games: LobbyGame[], device: DeviceType): LobbyGame[] {
  return games.filter((game) => {
    return game.exclude?.devices === undefined || !game.exclude?.devices?.includes(device);
  });
}
